var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10386 3.59776C9.45919 2.13408 11.5408 2.13408 11.8961 3.59776C12.1257 4.54327 13.209 4.99198 14.0398 4.48571C15.3261 3.70199 16.798 5.17392 16.0143 6.46015C15.508 7.29105 15.9567 8.37431 16.9022 8.60386C18.3659 8.95919 18.3659 11.0408 16.9022 11.3961C15.9567 11.6257 15.508 12.709 16.0143 13.5398C16.798 14.8261 15.3261 16.298 14.0398 15.5143C13.209 15.008 12.1257 15.4567 11.8961 16.4022C11.5408 17.8659 9.45919 17.8659 9.10386 16.4022C8.87431 15.4567 7.79105 15.008 6.96016 15.5143C5.67392 16.298 4.20199 14.8261 4.98571 13.5398C5.49198 12.709 5.04327 11.6257 4.09776 11.3961C2.63408 11.0408 2.63408 8.95919 4.09776 8.60386C5.04327 8.37431 5.49198 7.29105 4.98571 6.46015C4.20199 5.17392 5.67392 3.70199 6.96015 4.48571C7.79105 4.99198 8.87431 4.54327 9.10386 3.59776Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10C13 11.3807 11.8807 12.5 10.5 12.5C9.11929 12.5 8 11.3807 8 10C8 8.61929 9.11929 7.5 10.5 7.5C11.8807 7.5 13 8.61929 13 10Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.59c7f005463ef8364c8f2c5b1a91fec7.svg";
export { ForwardRef as ReactComponent };